/* eslint-env browser, jquery */
import page from 'modules/ab-page-js';
import landingAlias from 'modules/landing-alias';
import Batch from 'batch';
import rg from 'modules/npm-component/require-global';
import bus from 'modules/npm-component/bus';
import domify from 'domify';
import container from 'modules/section-content';
import request from 'superagent';
import _ from 'lodash';
import layout from './views/main.pug';
import universal from './universal/utils';

/**
 * Page.js routes
 */

export default function register() {
  landingAlias.forEach(alias => {
    // Technology index
    page(`/${alias}/:technology`, initial, render, loadScripts, initializePageSections);
    page.exit(`/${alias}/:technology`, exit);

    // Technologies index
    page(`/${alias}`, initial, render, loadScripts, initializePageSections);
    page.exit(`/${alias}`, exit);
  });
}

/**
 * Handle server-side and client-side render differently
 */
function initial(ctx, next) {
  if (ctx.init) {
    const metadata = window.authCatalogIndex && window.authCatalogIndex.metadata;
    container.render({ metadata });

    return next();
  }

  return clientRender(ctx, next);
}

/**
 * For all routes
 */
function render(ctx, next) {
  const refs = updateRefs();

  // Toggle loading flag by removing html's class and minimal header
  refs.$html.addClass('basic-navs-mode').removeClass('auth0-website-loading');

  // Prevent page update on key enter
  refs.$technologiesSearch.submit(e => {
    e.preventDefault();
  });

  refs.$input.on('keyup', onKeyUp);
  refs.$window.on('resize', onResize);

  onResize();

  bus.emit('page:render');

  return next();

  function onKeyUp(e) {
    return search(e, refs);
  }

  function onResize() {
    setHeights(refs);
  }
}

/**
 * Script loader
 */

function loadScripts(ctx, next) {
  const batch = new Batch();

  batch.push(done => {
    rg('//twitter.github.io/typeahead.js/releases/latest/typeahead.bundle.js', 'typeahead', done);
  });

  batch.end(next);
}

/**
 * Script page
 */

function initializePageSections(ctx, next) {
  const hoverCard = $('.hover-content');

  hoverCard.mouseenter(function() {
    hoverCard.css('opacity', '0.5');
    $(this).css('opacity', 1);
  });

  hoverCard.mouseleave(() => {
    hoverCard.css('opacity', 1);
  });

  next();
}

/**
 * Exit
 */
function exit(ctx, next) {
  const refs = updateRefs();
  refs.$window.off('resize', setHeights);

  return next();
}

/**
 * Search items
 */
function search(e, refs) {
  if (e.keyCode === 13) {
    // enter
    refs.$input.trigger('blur');
    return true;
  }
  const searchVal = _.trim(refs.$input.val()).toLowerCase();
  if (!searchVal) {
    refs.$items.removeClass('hidden');
    refs.$notfound.removeClass('show');
    setHeights(refs);

    return true;
  }

  for (const i in refs.itemsTitlesIndex) {
    // i = index of element
    const $item = refs.$items.eq(i);

    if (refs.itemsTitlesIndex[i].indexOf(searchVal) > -1) {
      $item.removeClass('hidden');
    } else {
      $item.addClass('hidden');
    }
  }

  setHeights(refs, refs.$items.filter(':visible'));
  refs.$notfound.toggleClass('show', refs.$items.not('.hidden').length === 0);
}

/**
 * Equal height items in rows
 */
function setHeights(refs, items) {
  items = items || refs.$items;
  items.css('height', 'auto');

  const perRow = Math.floor(refs.$container.width() / items.width());

  if (perRow === null || perRow < 2) {
    return true;
  }

  for (let i = 0, j = items.length; i < j; i += perRow) {
    let maxHeight = 0;
    const $row = items.slice(i, i + perRow);
    let $hoverContent = $('.hover-content'),
      $hoverContentHeight = $hoverContent.slice(i, i + perRow);

    $row.each(function() {
      const itemHeight = parseInt($(this).outerHeight());
      if (itemHeight > maxHeight) {
        maxHeight = itemHeight;
      }
    });
    $row.css('height', maxHeight);
    $hoverContentHeight.css('min-height', maxHeight);
  }
}

/**
 * Client-side render
 */
function clientRender(ctx, next) {
  if (ctx.state.data) {
    return performClientRender(ctx.state.data, ctx.state.metadata);
  }

  fetchAndRender();

  function fetchAndRender() {
    request.get('/api/auth-catalog').end(callback);
  }

  function callback(err, res) {
    if (err) {
      return handleError();
    }

    const data = _.clone(res.body);
    const technology = ctx.params.technology || '';
    const technologyTitle = universal.getTechnologyTitle(data.technologies, technology);
    const newMetadata = universal.seo(!!technology, ctx.path, technologyTitle);

    data.technology = technology;
    data.technologyTitle = technologyTitle;
    data.alias = ctx.path.split('/')[1];

    ctx.state.metadata = newMetadata;
    ctx.state.data = data;
    ctx.save();

    return performClientRender(data, newMetadata);
  }

  function handleError() {
    const refs = updateRefs();

    refs.$items.addClass('hidden');
    refs.$tryAgainMessage.addClass('show');
    refs.$tryAgainMessageLink.prop('href', ctx.path).one('click', e => {
      fetchAndRender();

      e.preventDefault();
    });

    return false;
  }

  function performClientRender(data, metadata) {
    container.render({ view: domify(layout(data)), metadata });

    return next();
  }
}

/**
 * DOM elements
 */
function updateRefs() {
  const container = $('.technology-list');
  const items = container.find('.technology-list__item');
  const itemsTitle = items.find('.technology__the-title');
  const itemsTitlesIndex = [];

  itemsTitle.each(function() {
    itemsTitlesIndex.push($(this).text().replace(/\s{2,}/g, ' ').toLowerCase());
  });

  return {
    $window: $(window),
    $html: $('html'),
    $technologiesSearch: $('.technologies-search'),
    $input: $('.technologies-search__input'),
    $container: container,
    $items: items,
    $itemsTitle: itemsTitle,
    itemsTitlesIndex,
    $notfound: $('.message--notfound'),
    $tryAgainMessage: $('.message--tryagain'),
    $tryAgainMessageLink: $('.message__link')
  };
}



// WEBPACK FOOTER //
// ./src/pages/auth-catalog-index/client.js